<template lang="pug">
el-dialog(
  v-draggable,
  v-if="flowLayoutType === 'PC'",
  :close-on-click-modal="false",
  append-to-body,
  :title="title",
  :fullscreen="fullscreen",
  custom-class="approve",
  :width="flowWidth",
  :visible.sync="flowDialog",
  :before-close="handleClose"
)
  #summary(:style="{ height: this.flowHeight }")
    vFormRender(ref="vFormRender", :formId="formId", :formCode="formCode", :flowLayoutType="flowLayoutType", :primaryKeyValue="primaryKeyValue", @loadComplete="loadComplete")
van-dialog.vFRH5(v-else-if="flowLayoutType === 'H5'", :title="title", v-model="flowDialog", confirm-button-color="#3873FE")
  vFormRender.vFRH5_view(
    ref="vFormRender",
    :formId="formId",
    :formCode="formCode",
    :flowLayoutType="flowLayoutType",
    :primaryKeyValue="primaryKeyValue",
    @loadComplete="loadComplete"
  )
</template>

<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import vFormRender from "./vFormRender.vue";
export default {
  components: { vFormRender },
  mixins: [asyncMixin],
  props: {
    dialogHeight: {
      type: String,
      default: ""
    },
    dialogWidth: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "表单"
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    // 表单id
    formId: {
      type: String,
      default: ""
    },
    // 表单数据回显
    primaryKeyValue: {
      type: String,
      default: ""
    },
    formCode: {
      type: String,
      default: ""
    },
    flowLayoutType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      flowDialog: !false
    };
  },
  computed: {
    flowWidth() {
      return this.dialogWidth ? this.dialogWidth + "px" : "60%";
    },
    flowHeight() {
      return this.dialogHeight ? this.dialogHeight + "px" : "100%";
    }
  },
  methods: {
    loadComplete() {
      this.$refs.vFormRender.disableForm?.();
    },
    handleClose() {
      this.resolve();
      this.flowDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#summary {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .fullscreen {
    height: 100%;
  }
}
</style>
<style lang="scss">
.vFRH5 {
  .van-dialog__header {
    padding-top: 10px;
    border-bottom: 1px solid #f5f5f5;
  }
  .vFRH5_view {
    padding-top: 5px;
  }
}
</style>
